var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14 8.568a1.5 1.5 0 001.71-.912A5.002 5.002 0 0119.5 9.5a5.001 5.001 0 01-4.25 4.944v.056c0 .51-.047 1-.133 1.471a6.5 6.5 0 10-6.66-8.87A4.5 4.5 0 107.5 16h4.52c.147-.47.23-.972.23-1.499H7.5a3 3 0 11.64-5.932zm.373 11.97C10.546 19.86 13 17.591 13 14.5v-3.94l-.72.72a.75.75 0 01-1.06-1.06l1.998-1.999a.747.747 0 011.08.016l1.982 1.983a.75.75 0 11-1.06 1.06l-.72-.72v3.94c0 3.907-3.046 6.639-5.513 7.461a.75.75 0 11-.474-1.423z",
    fill: "currentColor"
  })));
}

export default SvgUpload;